import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import {Box, Button, TextField} from '@material-ui/core'
import {connect} from 'react-redux'
import {dataActions} from '../../../../../actions'
import useForm from '../../../../../components/useForm'

const useStyles = makeStyles(theme => ({
    titleBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    boundaryBox: {
        margin: '15px 0',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    archiveButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '100%',
    },
}))

const EditDepartment = props => {
    const classes = useStyles()
    const {
        token,
        handleCloseDialog,
        handleToggleStatus,
        departmentslist,
        activedepartment,
        updateDepartment,
        deleteDepartment,
    } = props

    let payload = {}

    const initFormValues = {
        departmentname: activedepartment.name || '',
    }

    const {values, isChanged, handleChange, handleSubmit} = useForm(
        submiteditdepartment,
        initFormValues
    )

    payload = {
        values,
        activedepartment,
    }

    function submiteditdepartment() {
        updateDepartment(token, payload)
        handleCloseDialog()
    }

    function handleDelete() {
        deleteDepartment(token, payload)
        handleCloseDialog()
    }

    const handleArchive = async () => {
        let newStatus = activedepartment.status === 'I' ? 'A' : 'I'
        let archivedepartment = {
            ...activedepartment,
            status: newStatus,
        }
        payload = {values, activedepartment: archivedepartment}

        await updateDepartment(token, payload)
        handleToggleStatus(newStatus)
        handleCloseDialog()
    }

    const nameduplicate = departmentslist.filter(
        dept =>
            dept.name === values.departmentname &&
            dept.deptId !== activedepartment.deptId
    )

    const nameerror = []
    if (nameduplicate.length > 0)
        nameerror.push(
            'Duplicate Name detected in ' +
                (nameduplicate[0].status === 'A' ? 'Active' : 'Inactive') +
                ' Departments'
        )

    if (values.departmentname.length > 50)
        nameerror.push('Department Name cannot exceed 50 characters')

    return (
        <>
            <form onSubmit={handleSubmit}>
                <Box className={classes.boundaryBox}>
                    <TextField
                        id="departmentname"
                        name="departmentname"
                        label="Department Name"
                        fullWidth
                        autoFocus
                        autoComplete="off"
                        margin="normal"
                        variant="outlined"
                        required
                        error={nameerror.length > 0}
                        helperText={nameerror.join()}
                        value={values.departmentname}
                        onChange={handleChange}
                    />
                </Box>
                <Box className={classes.boundaryBox}>
                    <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        disabled={nameerror.length > 0 || !isChanged}
                        className={classes.submitButton}
                    >
                        Update Department
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        size="medium"
                        disabled={nameerror.length > 0}
                        className={classes.archiveButton}
                        onClick={handleArchive}
                    >
                        {activedepartment.status === 'I'
                            ? 'Re-Activate'
                            : 'Inactivate'}
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        size="medium"
                        disabled={nameerror.length > 0}
                        className={classes.archiveButton}
                        onClick={handleDelete}
                    >
                        Delete Department
                    </Button>
                </Box>
            </form>
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        activedepartment: state.departmentsdata.manageroledept,
        defaultdepartment: state.authentication.departmentslist[0],
        departmentslist: state.departmentsdata.departmentslist,
    }
}

const mapDispatchToProps = {
    updateDepartment: (token, payload) =>
        dataActions.manageroledeptUpdateRequest(token, payload),
    deleteDepartment: (token, payload) =>
        dataActions.manageroledeptDeleteRequest(token, payload),
    clearDepartment: department =>
        dataActions.manageroledeptSetClear(department),
}

export default connect(mapStateToProps, mapDispatchToProps)(EditDepartment)
